/* ProminentSectionInfo.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _4 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _3 = "._18s81z0f{margin:var(--ds-space-200) 0}";
const _2 = "._syaz6g14{color:var(--ds-text-accent-purple)}";
import { BodyLarge, H2, LinkWithIcon } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
const _ = "._1yt4l6l0{padding:var(--ds-space-300)}";
export const Card = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt4l6l0", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const Heading = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H2,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz6g14", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
const Description = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18s81z0f _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
export const ProminentSectionInfo = _ref4 => {
  let {
    title,
    description,
    navigationUrl
  } = _ref4;
  const history = useHistory();
  const {
    tractExploreMoreAppClick
  } = useHomepageAnalytics();
  const navigationLinkClickHandler = event => {
    event.preventDefault();
    if (navigationUrl) tractExploreMoreAppClick(title, navigationUrl);
    history === null || history === void 0 ? void 0 : history.push(navigationUrl);
  };
  const ariaLabel = title.toLowerCase().includes('apps') ? "Explore more ".concat(title) : "Explore more ".concat(title, " apps");
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Heading, null, title), /*#__PURE__*/React.createElement(Description, null, description), navigationUrl && /*#__PURE__*/React.createElement(LinkWithIcon, {
    size: "medium",
    type: "internal",
    onClick: event => navigationLinkClickHandler(event),
    href: navigationUrl,
    "aria-label": ariaLabel
  }, "Explore more apps"));
};